import React from "react";
import {Card, Header, Icon, List, Grid} from "semantic-ui-react";
import {TicketDetails} from "./TicketModels";
import {dateWithTimeToString, getDateFromString} from "@/util/dateUtil";
import {IBusinessUnit} from "../application/api/applicationModels";

interface TicketInfoProps {
    locationId: number;
    ticket: TicketDetails;
    clientTreeHierarchy: IBusinessUnit[];
    conceptName: string;
}

export const TicketInfo: React.FC<TicketInfoProps> = ({
    locationId,
    ticket,
    clientTreeHierarchy,
    conceptName
}) => {
    const toTitleCase = (str?: string) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase()) : "";
    };
    //The Delaget API does not return the business unit name directly, so we need to find it in the hierarchy
    const getBusinessUnit = () => {
        const businessUnit = clientTreeHierarchy.find(
            (bu) => bu.businessUnitPk === locationId
        );
        return businessUnit || undefined;
    };

    const businessUnit = getBusinessUnit();

    return (
        <Card fluid>
            <Card.Content>
                <Grid columns={2}>
                    <Grid.Column>
                        {(businessUnit && businessUnit.businessUnitName) ||
                        conceptName ? (
                            <div style={{display: "flex", alignItems: "flex-start"}}>
                                <Icon
                                    name="building"
                                    size="large"
                                    style={{marginRight: "10px", marginTop: "2px"}}
                                />
                                <div>
                                    {businessUnit &&
                                        businessUnit.businessUnitName && (
                                            <Header as="h3" style={{margin: "0"}}>
                                                {businessUnit.businessUnitName}{" "}
                                                {
                                                    businessUnit.businessUnitDescription
                                                }
                                            </Header>
                                        )}
                                    {conceptName && (
                                        <Header
                                            as="h4"
                                            style={{margin: "0 0 5px 0"}}
                                        >
                                            {conceptName}
                                        </Header>
                                    )}
                                </div>
                            </div>
                        ) : null}
                    </Grid.Column>

                    <Grid.Column>
                        <List relaxed>
                            <List.Item>
                                <Icon name="user" />
                                <List.Content>
                                    <strong>Cashier:</strong>{" "}
                                    {ticket.orderUserName
                                        ? toTitleCase(ticket.orderUserName)
                                        : "UNKNOWN"}
                                </List.Content>
                            </List.Item>
                            {ticket.registerNumber && ticket.registerNumber !== 'UNKNOWN' && (
                                <List.Item>
                                    <Icon name="desktop" />
                                    <List.Content>
                                        <strong>Register:</strong>{" "}
                                        {ticket.registerNumber}
                                    </List.Content>
                                </List.Item>
                            )}
                            <List.Item>
                                <Icon name="calendar" />
                                <List.Content>
                                    <strong>Opened:</strong>{" "}
                                    {ticket.orderTime
                                        ? dateWithTimeToString(
                                              getDateFromString(ticket.orderTime)
                                          )
                                        : ""}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <Icon name="calendar" />
                                <List.Content>
                                    <strong>Closed:</strong>{" "}
                                    {ticket.closedTime
                                        ? dateWithTimeToString(
                                              getDateFromString(ticket.closedTime)
                                          )
                                        : ""}
                                </List.Content>
                            </List.Item>
                        </List>
                    </Grid.Column>
                </Grid>
            </Card.Content>
        </Card>
    );
};
